import Transform from "@ember-data/serializer/transform";
import type { MedicationRequestPayload } from "parog-web/models/prescriptions/medication-request";
import MedicationRequest from "parog-web/models/prescriptions/medication-request";

export default class MedicationRequestsTransform extends Transform<
  MedicationRequest[],
  Array<MedicationRequestPayload>
> {
  override deserialize(
    serialized: Array<MedicationRequestPayload>
  ): MedicationRequest[] {
    return serialized.map(medicationRequest =>
      MedicationRequest.fromPayload(medicationRequest)
    );
  }

  override serialize(
    deserialized: MedicationRequest[]
  ): Array<MedicationRequestPayload> {
    return deserialized.map(medicationRequest => medicationRequest.jsonPayload);
  }
}

declare module "ember-data/types/registries/transform" {
  export default interface TransformRegistry {
    "medication-requests": MedicationRequestsTransform;
  }
}
